import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, formatApiErrorDetail } from "./api";

const AuthContext = createContext({
  user: null,        // null = checking, false = not authed, object = authed
  login: async () => {},
  logout: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const probe = useCallback(async () => {
    const t = getToken();
    if (!t) { setUser(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (e) {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => { probe(); }, [probe]);

  const login = async (email, password) => {
    try {
      const r = await api.post("/auth/login", { email, password });
      setToken(r.data.access_token);
      setUser(r.data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
